import { z } from 'zod';

/** Which deployment a build targets. Separate from `NODE_ENV`, which stays `production` for every deployed build. */
export const BlockitEnvSchema = z.enum({
  DEV: 'dev',
  STAGING: 'staging',
  PROD: 'prod',
});
export type BlockitEnv = z.infer<typeof BlockitEnvSchema>;
export const BlockitEnvEnumValue = BlockitEnvSchema.enum;
